module.exports = __webpack_public_path__ + "static/img/icon_medal.72b5a5a2.svg";